import ProfilePage from 'content/pages/Private/Profile';
import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const UsersPage = Loader(lazy(() => import('content/pages/Private/UsersPage')));

const usersRouter: RouteObject[] = [
  {
    path: 'users',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <UsersPage />,
      },
    ],
  },
  {
    path: 'profile',
    element: <ProfilePage />,
  },
];

export default usersRouter;
